import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import RenderStatus from "../../styles/styledStatus";
import { TimestampToDateMoment } from "../../../utils/timestampToDate";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Tooltip } from "@material-ui/core";
import Notification from "../../elements/notification/Notification";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../styles/styledTable";
import { StyledTooltip } from "../../styles/styledTooltip";
import { StyledCopy } from "../../styles/styledCopy";
import { StyledBreakWord } from "../../styles/styledBreakWord";

const PayoutList = ({ payouts }) => {
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  if (!payouts) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (payouts.length === 0) {
    return <Alert severity="warning">Выплаты отсутствуют</Alert>;
  }

  const showDetails = (e) => {
    if (e.target.closest(".stop-event")) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledScrollTable className="payout-table_scroll">
        <StyledTable
          width="2870"
          size="16"
          className="payout-table"
        >
          <StyledTableHead
            scroll="auto"
            col="12"
            className="payout-table__head"
          >
            <div>
              Id
              <Tooltip title="Уникальный идентификатор транзакции в системе Control Panel" arrow placement="top">
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              Reference id
              <Tooltip title="Уникальный идентификатор транзакции передаваемый по API" arrow placement="top">
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              Проект
            </div>
            <div>
              Сервис
            </div>
            <div>
              Платежная система
            </div>
            <div>
              Валюта
            </div>
            <div>
              Заявленная сумма
              <Tooltip title="Сумма выплаченная клиенту" arrow placement="top">
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              Выплаченная сумма
              <Tooltip title="Сумма списанная с баланса Control Panel" arrow placement="top">
                <StyledTooltip className="icon-light-help" />
              </Tooltip>
            </div>
            <div>
              Статус
            </div>
            <div>
              Дата создания
            </div>
            <div>
              Дата обновления
            </div>
            <div>
              Тип платежа
            </div>
            <div>
              Тип транзакции
            </div>
            <div>
              Related reference id
            </div>
            <div>
              Примечание
            </div>
          </StyledTableHead>
          <StyledTableBody>
            {payouts && payouts.map((value, key) => (
              <StyledTableRow
                key={key}
                scroll="auto"
                col="12"
                className="payout-table__row"
                onClick={(e) => {showDetails(e);}}
                cursor="pointer"
                as={NavLink}
                to={`/payouts/${value.id}`}
              >
                <StyledCol inline data-title="id">
                  <CopyToClipboard
                    className="stop-event"
                    text={value.id}
                    onCopy={() => {
                      setNotification({ ...notification, visible: true, type: "success", message: "Скопировано" });
                    }}
                  >
                    <StyledBreakWord as="p">
                      {value.id} <StyledCopy title="Скопировать" className="icon-light-copy" />
                    </StyledBreakWord>
                  </CopyToClipboard>
                </StyledCol>
                <StyledCol inline data-title="Reference id">
                  <CopyToClipboard
                    className="stop-event"
                    text={value.referenceId}
                    onCopy={() => {
                      setNotification({ ...notification, visible: true, type: "success", message: "Скопировано" });
                    }}
                  >
                    <StyledBreakWord as="p">
                      {value.referenceId} <StyledCopy title="Скопировать" className="icon-light-copy" />
                    </StyledBreakWord>
                  </CopyToClipboard>
                </StyledCol>
                <StyledCol data-title="Проект">
                  {value.connection.project.name}
                </StyledCol>
                <StyledCol data-title="Сервис">
                  {getServiceNameWithNickname(value.connection.service.name, value.connection.service.nickname)}
                </StyledCol>
                <StyledCol data-title="Платежная система">
                  {value.paymentSystem.name}
                </StyledCol>
                <StyledCol data-title="Валюта">
                  {value.currency.asset}
                </StyledCol>
                <StyledCol data-title="Заявленная сумма">
                  {value.amount}
                </StyledCol>
                <StyledCol data-title="Выплаченная сумма">
                  {value.currency.type === "CRYPTO" ? value.amount : value.processedAmount}
                </StyledCol>
                <StyledCol inline data-title="Статус">
                  <RenderStatus status={value.status.value} />
                </StyledCol>
                <StyledCol data-title="Дата">
                  {TimestampToDateMoment(value.createdAt)}
                </StyledCol>
                <StyledCol data-title="Дата">
                  {TimestampToDateMoment(value.updatedAt)}
                </StyledCol>
                <StyledCol data-title="Тип платежа">
                  {value.paymentType}
                </StyledCol>
                <StyledCol data-title="Тип транзакции">
                  {value.transactionType}
                </StyledCol>
                <StyledCol data-title="Related reference id">
                  {value.relatedReferenceId}
                </StyledCol>
                <StyledCol inline data-title="Примечание" className="payment-table__note">
                  <p className="note">
                    {value.note}
                  </p>
                  {value.note && value.note.length > 25 &&
                    <Tooltip
                      title={value.note}
                      arrow
                      placement="top"
                    >
                      <StyledTooltip className="icon-light-info" />
                    </Tooltip>}
                </StyledCol>
              </StyledTableRow>
            ))}
          </StyledTableBody>
        </StyledTable>
      </StyledScrollTable>
    </>
  );
};

export default PayoutList;